import RecipientList from 'features/v2a/sender/components/RecipientList';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import VXLTextInput from 'shared/components/vxl/input/VXLTextInput/VXLTextInput';
import theme from 'shared/styles/theme';

const SearchRecipientScreen = () => {
  const [searchPhrase, setSearchPhrase] = useState('');
  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'sender',
  });

  return (
    <View style={styles.container}>
      <View style={styles.searchBar}>
        <VXLTextInput
          testID="text-input-searchbox"
          labelText={translatedText('recipients.searchTitle')}
          autoCapitalize="none"
          onChangeText={setSearchPhrase}
          placeholder={translatedText('recipients.searchBarPlaceHolder')}
          value={searchPhrase}
        />
      </View>
      <RecipientList searchPhrase={searchPhrase} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    width: '100%',
  },
  searchBar: {
    paddingHorizontal: theme.spacing.m,
  },
});

export default SearchRecipientScreen;
